"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Statuses = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

var _core = require("@lingui/core");

var lists = _interopRequireWildcard(require("../../../Action/utils/lists"));

var _EditableMenu = require("./EditableMenu");

var _hooks = require("../hooks");

const Container = _styledComponents.default.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin-top: ${_blocks.spacing.default};
  /*
  * negative margin bottom on Container to hedge the positive margin bottom on Chip
  **/
  margin-bottom: -${_blocks.spacing.tight};
  /* Targeting Chip within the container */
  > span {
    margin-bottom: ${_blocks.spacing.tight};
  }
`;

const Statuses = ({
  status,
  severity,
  type,
  editFn
}) => {
  const disabledStatuses = (0, _hooks.useEditDisabledStatuses)();
  return /*#__PURE__*/React.createElement(Container, null, status !== undefined && /*#__PURE__*/React.createElement(_EditableMenu.EditableMenu, {
    label: _core.i18n._({
      id: 'action_details.statuses.status',
      message: `Status`
    }),
    field: "status",
    selected: status,
    onSelect: editFn,
    options: lists.getStatusOptions(_core.i18n, disabledStatuses)
  }), severity !== undefined && /*#__PURE__*/React.createElement(_EditableMenu.EditableMenu, {
    label: _core.i18n._({
      id: 'action_details.statuses.severity',
      message: `Severity`
    }),
    field: "priority",
    selected: severity,
    onSelect: editFn,
    options: lists.getPriorityOptions(_core.i18n)
  }), type !== undefined && /*#__PURE__*/React.createElement(_EditableMenu.EditableMenu, {
    label: _core.i18n._({
      id: 'action_details.statuses.type',
      message: `Type`
    }),
    field: "context",
    selected: type,
    onSelect: editFn,
    options: lists.getContextOptions(_core.i18n)
  }));
};

exports.Statuses = Statuses;